import React, { useEffect, useRef, useState } from 'react';
import Flyover from '../../components/UI/Flyover';
import { useDispatch } from 'react-redux';
import { fetchTimeline, clearTimeline } from '../../actions/timeline.actions';

export default function HeaderChatMenu({
    chatId,
    anchorRightRef,
    open,
    onClose,
    width = 320,
    // опциональные колбэки из родителя (HeaderChatUI):
    onSearch,     // (params: { q?, dateFrom?, dateTo? }) => void
    onFilter,     // (only: 'image'|'video'|'voice'|'doc'|'media'|'link') => void
    showSearch = true,
    showMedia = true,
}) {
    const dispatch = useDispatch();
    const btnRef = useRef(null);

    // локальный UI-состояния поиска
    const [q, setQ] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    useEffect(() => {
        if (anchorRightRef) btnRef.current = anchorRightRef.current;
    }, [anchorRightRef]);

    const fallbackFilter = (only) => {
        if (!chatId) return;
        dispatch(clearTimeline(chatId));
        dispatch(fetchTimeline(chatId, { limit: 15, only }));
    };

    const fallbackSearch = () => {
        if (!chatId) return;
        dispatch(clearTimeline(chatId));
        dispatch(fetchTimeline(chatId, {
            limit: 15,
            q: q || undefined,
            dateFrom: dateFrom || undefined,
            dateTo: dateTo || undefined
        }));
    };

    const runFilter = (only) => {
        if (onFilter) onFilter(only);
        else fallbackFilter(only);
        onClose?.();
    };

    const runSearch = (e) => {
        e?.preventDefault?.();
        if (onSearch) onSearch({ q, dateFrom, dateTo });
        else fallbackSearch();
        onClose?.();
    };

    if (!open) return null;

    return (
        <Flyover
            anchorRef={{ current: btnRef.current || anchorRightRef?.current }}
            onClose={onClose}
            preferredPlacement="bottom"
            align="end"
            width={width}
        >
            <div className="flyover__list">
                {/* {showSearch && (
                    <div style={{ padding: 8, borderBottom: '1px solid #1f2937' }}>
                        <div style={{ fontWeight: 700, marginBottom: 8 }}>Поиск в чате</div>
                        <form onSubmit={runSearch} style={{ display: 'grid', gap: 8 }}>
                            <input
                                type="text"
                                placeholder="Текст или имя файла…"
                                value={q}
                                onChange={(e) => setQ(e.target.value)}
                                style={{ padding: 8, borderRadius: 8, border: '1px solid #1f2937', background: '#0f172a', color: '#e5e7eb' }}
                            />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                                <input
                                    type="date"
                                    value={dateFrom}
                                    onChange={(e) => setDateFrom(e.target.value)}
                                    style={{ padding: 8, borderRadius: 8, border: '1px solid #1f2937', background: '#0f172a', color: '#e5e7eb' }}
                                />
                                <input
                                    type="date"
                                    value={dateTo}
                                    onChange={(e) => setDateTo(e.target.value)}
                                    style={{ padding: 8, borderRadius: 8, border: '1px solid #1f2937', background: '#0f172a', color: '#e5e7eb' }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                <button
                                    type="button"
                                    className="flyover__item"
                                    onClick={() => { setQ(''); setDateFrom(''); setDateTo(''); }}
                                >Сброс</button>
                                <button type="submit" className="flyover__item">Искать</button>
                            </div>
                        </form>
                    </div>
                )} */}

                {showMedia && (
                    <div style={{ padding: 8 }}>
                        <div style={{ color: "white", fontWeight: 700, margin: '6px 0 8px' }}>Медиа</div>
                        <div style={{ display: 'grid', gap: 6 }}>
                            <button className="flyover__item" onClick={() => runFilter('image')}>📷 Фото</button>
                            <button className="flyover__item" onClick={() => runFilter('video')}>🎞 Видео</button>
                            <button className="flyover__item" onClick={() => runFilter('voice')}>🎙 Голосовые</button>
                            <button className="flyover__item" onClick={() => runFilter('doc')}>📎 Файлы</button>
                            <button className="flyover__item" onClick={() => runFilter('media')}>🧩 Все медиа</button>
                            <button className="flyover__item" onClick={() => runFilter('link')}>🔗 Ссылки</button>
                        </div>
                    </div>
                )}
            </div>
        </Flyover>
    );
}
